module.exports = __webpack_public_path__ + "static/media/IMG_20141123_175228.4c044067.jpg";